import { map, OperatorFunction } from 'rxjs';

const DEFAULT_TRANSLATIONS: string[][] = [
  ['Organic', $localize`Orgánico`],
  ['Campaign', $localize`Campaña`],
  ['Campaigns', $localize`Campañas`],
];

export const translateSourcesMapperI18n = <T>(
  sourceTranslations = DEFAULT_TRANSLATIONS
): OperatorFunction<T, T> =>
  map((response) => {
    if (response) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data } = response as any;
      if ('object' === typeof response && 'object' === typeof data) {
        let dataStr = JSON.stringify(data);
        let hasChanges = false;
        for (const [source, dest] of sourceTranslations) {
          if (dataStr.includes(`"${source}"`)) {
            dataStr = dataStr.replaceAll(`"${source}"`, `"${dest}"`);
            hasChanges = true;
          }
        }
        if (hasChanges) {
          Object.assign(response, { data: JSON.parse(dataStr) });
        }
      }
    }
    return response;
  });
